import { ProgressChart } from '../../../../components/CHARTS/Progress/ProgressChart';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import Input from '../../../../components/Inputs/Input';
import { SearchBar } from '../../../../components/SearchBar/SearchBar';
import { defaultColorGradient } from '../../../../components/TimeControls/TimeControls';
import './SpecificSchedule.scss';

const mockSerials = [
    "SN85584927A",
    "SN39472810B",
    "SN10293847C",
    "SN74839201D",
    "SN58392047E",
    "SN92837465F",
    "SN38475629G",
    "SN19283746H",
    "SN47583920J",
    "SN83920174K"
];
export const SpecificSchedule = () => {
    return (
        <div className='specific-schedule-component'>
            <div className='serials general-card-component'>
                <SearchBar onChange={() => { }} />
                <div className='serial-list'>
                    {mockSerials.map(s => <div className='serial-item'>{s}</div>)}

                </div>
            </div>
            <div className='schedule general-card-component'>
                <div className='schedule-header'>
                    <div className='title'>

                        <b>Schedule Serial Number - SN85584927A </b>
                        <CheckboxField>Latest</CheckboxField>
                        <CheckboxField>Use Flight Days</CheckboxField>
                        <CheckboxField>Override</CheckboxField>
                    </div>
                    <div className='repeat-container'>
                        <i className='icon-info'></i>
                        <b>Repeated Count</b>
                        <span className='count'>
                            1
                        </span>

                    </div>

                </div>
                <div className='schedule-grid'>
                    <b>Threshold</b>
                    <Input label="Hours"></Input>
                    <Input label="Cycles"></Input>
                    <Input label="Days"></Input>
                    <i></i>
                    <Input label="Total Hours"></Input>
                    <Input label="Total Cycles"></Input>
                    <Input label="Total Days"></Input>
                    <i></i>
                    <BasicDatePicker label="Schedule Date" />
                    <hr></hr>
                    <b>Interval</b>
                    <Input label="Hours"></Input>
                    <Input label="Cycles"></Input>
                    <Input label="Days"></Input>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <BasicDatePicker label="Schedule Date" />


                </div>

                <div className='time-control general-card-component'>
                    {/* <div className='title'> <b>A7256610-1</b>  <i>Functional Check</i>     </div> */}
                    <div className='controls'>
                        <ProgressChart data={{ "Hours": { max: 1000, min: 0, value: 750, colorGradient: defaultColorGradient, showValueLabel: true } }} />
                        <i></i>
                        <ProgressChart data={{ "Cycles": { max: 1000, min: 0, value: 750, colorGradient: defaultColorGradient, showValueLabel: true } }} />
                        <i></i>
                        <ProgressChart data={{ "Days": { max: 1000, min: 0, value: 750, colorGradient: defaultColorGradient, showValueLabel: true } }} />
                    </div>

                </div>

            </div>

        </div>
    )

}